export default {
    hostname: process.env.NODE_ENV == "development" ? 'http://' + window.location.host + '/backend' : 'https://' + window.location.host + '/backend'
}
